import { accountHandoffUrl } from "@/lib/canonical-link";
import { readTabAccountId } from "@/lib/tab-account";

let installed = false;

function anchorFromEvent(event: Event): HTMLAnchorElement | null {
  const path = event.composedPath();
  for (const node of path) {
    if (node instanceof HTMLAnchorElement) {
      return node;
    }
  }
  return null;
}

function isInAppAnchor(anchor: HTMLAnchorElement): boolean {
  if (anchor.target !== "" || anchor.hasAttribute("download")) {
    return false;
  }
  const href = anchor.getAttribute("href");
  if (href === null || href === "" || href.startsWith("#")) {
    return false;
  }
  try {
    return new URL(anchor.href).origin === globalThis.location.origin;
  } catch {
    return false;
  }
}

function opensInNewTab(event: MouseEvent): boolean {
  if (event.shiftKey) {
    return false;
  }
  return event.ctrlKey || event.metaKey || event.button === 1;
}

function handleClick(event: MouseEvent): void {
  if (event.defaultPrevented || !opensInNewTab(event)) {
    return;
  }
  const anchor = anchorFromEvent(event);
  if (!anchor || !isInAppAnchor(anchor)) {
    return;
  }
  const userId = readTabAccountId();
  if (userId === null) {
    return;
  }
  event.preventDefault();
  globalThis.open(accountHandoffUrl(anchor.href, userId), "_blank");
}

export function installNewTabAccountHandoff(): void {
  if (installed || typeof globalThis.addEventListener !== "function") {
    return;
  }
  installed = true;
  globalThis.addEventListener("click", handleClick, { capture: true });
  globalThis.addEventListener("auxclick", handleClick, { capture: true });
}
